import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CryptoJS from 'crypto-js';
import { useSelector, useDispatch } from 'react-redux';
import { updateField } from 'actions/common';
import { SET_USER_EMAIL, SET_USER_PASSWORD, USER_INITIATE } from 'actions/user';
import Dialog from '@material-ui/core/Dialog';
import Button from 'components/Button';
import TextField from 'components/TextField';
import COLORS from 'shared/constants/colors';
import AccountInformationDialog from 'pages/home/Header/AccountInformationDialog';
import { login } from 'actions/auth';
import logo from 'assets/images/shirtly_logo_blue.svg';
import {
  Container,
  Header,
  Body,
  ForgetPassword,
  Footer,
} from 'styles/pages/home/loginDialog';

const LoginDialog = ({
  open,
  onClose,
  showSignUpModal,
  forgotPasswordDialog,
}) => {
  const dispatch = useDispatch();
  const [loginError, setLoginError] = useState(false);
  const user = useSelector((state) => state?.user);
  const email = user?.email;
  const password = user?.password;
  const disabled = !email?.valid || !password?.valid;
  const [accountInFoDialogVisibility, setAccountInfoDialog] = useState(false);

  const loginSubmit = async () => {
    const request = await dispatch(
      login({
        email: email?.value,
        password: CryptoJS.AES.encrypt(password?.value, 'bot').toString(),
      })
    );

    if (request?.error && (request.inProcess || request.declined)) {
      setAccountInfoDialog({
        show: true,
        inProcess: request.inProcess,
      });
      return;
    }

    if (request?.error) {
      setLoginError(request?.message);
      return;
    }
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      loginSubmit();
    }
  };

  return (
    <Dialog
      maxWidth='md'
      open={open}
      onClose={() => {
        dispatch(updateField(USER_INITIATE));
        _.isFunction(onClose) && onClose();
      }}>
      <Container>
        <Header>
          <img src='https://bigoventees.com/img/back2.png' alt='logo' />
          <h4>Welcome Back to Big Oven Tees</h4>
        </Header>
        <Body>
          <TextField
            fullWidth
            size='small'
            label='Email'
            onKeyDown={onKeyDown}
            error={!!(email?.value && !email?.valid) || !!loginError}
            helperText={
              email?.value && !email?.valid
                ? 'Enter valid email'
                : loginError
                ? loginError
                : null
            }
            value={email?.value || ''}
            onChange={(v) => {
              dispatch(updateField(SET_USER_EMAIL, { email: v }));
              if (loginError) {
                setLoginError(false);
              }
            }}
          />
          <TextField
            fullWidth
            size='small'
            label='Password'
            type='password'
            onKeyDown={onKeyDown}
            error={!!(password?.value && !password?.valid) || !!loginError}
            helperText={
              password?.value && !password?.valid
                ? `Password should be of minimum ${password.MINIMUM_PASSWORD_LENGTH} characters `
                : loginError
                ? loginError
                : null
            }
            value={password?.value || ''}
            onChange={(v) => {
              dispatch(updateField(SET_USER_PASSWORD, { password: v }));
              if (loginError) {
                setLoginError(false);
              }
            }}
          />
          {/* <CustomCheckbox label='Remember me' /> */}
          <Button
            disabled={disabled}
            variant='contained'
            title='Login'
            onClick={loginSubmit}
          />

          <p>Do not have an account?</p>
          <Button
            containerStyle={{
              backgroundColor: COLORS.WHITE,
              fontize: '15px',
              color: ' #272742',
              textDecoration: 'underline',
              marginTop: '5px',
              cursor: 'pointer',
              textTransform: 'unset',
              justifyContent: 'unset',
              padding: 0,
            }}
            variant='text'
            title='Create an account'
            onClick={() => _.isFunction(showSignUpModal) && showSignUpModal()}
          />

          <ForgetPassword onClick={forgotPasswordDialog}>
            Forgot your Password?
          </ForgetPassword>
        </Body>
        <Footer>
          <p>© Big Oven Tees</p>
          <p>2014 -2021</p>
        </Footer>
      </Container>
      {accountInFoDialogVisibility.show && (
        <AccountInformationDialog
          open={accountInFoDialogVisibility.show}
          inProcess={accountInFoDialogVisibility.inProcess}
          onClose={() => {
            setAccountInfoDialog({
              show: false,
            });
            _.isFunction(onClose) && onClose();
          }}
        />
      )}
    </Dialog>
  );
};

LoginDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LoginDialog;
